export default {
  name: 'marking--returnPrimaryDocType',
};